import { isPlatform } from '../utils/isPlatform';
import { RefObject } from 'react';

type IAutoFocusComponents = HTMLIonInputElement | HTMLIonTextareaElement | HTMLIonSearchbarElement;

export const useAutoFocus = (ref: RefObject<IAutoFocusComponents>) => {
    return () => {
        setTimeout(() => {
            if (isPlatform('desktop') || isPlatform('capacitor')) {
                ref?.current?.setFocus();
            }
        }, 50);
    };
};
